export const styles = {
  socialContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'left',
    alignContent: 'center',
    height: 64,
    border: '1px solid #E2E2FC',
    borderRadius: '8px',
    paddingRight: '32px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f0f0f0',
      transition: 'all 0.5s ease',
    },
  },
  iconContainer: {
    padding: 16,
  },
  textContainer: {
    display: 'flex',
    padding: '18px 36px 18px 12px',
    width: '100%',
  },
  text: {
    textAlign: 'center',
    width: '100%',
    fontSize: '18px',
    color: '#80868B',
    whiteSpace: 'nowrap',
    alignSelf: 'flex-end',
    '@media (max-width: 340px)': {
      fontSize: '15px',
    },
  },
}
